import React from "react";
import CommonCsvExport from "./CommonCsvExport";
import { useOutletContext } from "react-router-dom";
import { User } from "../types";

const WorkLogExport = () => {
  const user = useOutletContext<User | null>();
  const closingDateStr = user?.current_closing_date || null;

  return (
    <CommonCsvExport
      pageTitle="業務報告出力"
      cardTitle="期間指定ダウンロード"
      description={
        <>
          指定した期間の全ユーザーの業務報告データをCSV形式で出力します。
          <br />
          Excelでそのまま開ける形式（UTF-8 BOM付）です。
          {closingDateStr && (
            <div className="mt-2 text-danger fw-bold">
              ※出力可能なデータは、締め処理済みの期間（{closingDateStr}{" "}
              まで）に限定されています。
            </div>
          )}
        </>
      }
      apiPath="/api/work_log_exports"
      fileNamePrefix="work_logs"
      maxDate={closingDateStr}
    />
  );
};

export default WorkLogExport;
